// **********************************************************
// Hero slider
// **********************************************************

const heroSwiperElements = document.querySelectorAll('[data-slider="hero-slider"]');
const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

heroSwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.hero-slider');
  const arrowRight = mainSliderParent.querySelectorAll('.swiper-button-next')[0];
  const arrowLeft = mainSliderParent.querySelectorAll('.swiper-button-prev')[0];
  const paginationElement = mainSliderParent.querySelectorAll('.swiper-pagination')[0];

  heroSliderOptions.navigation.nextEl = arrowRight;
  heroSliderOptions.navigation.prevEl = arrowLeft;
  heroSliderOptions.pagination.el = paginationElement;

  new Swiper(el, heroSliderOptions);

  // **************************************

  const pagination = el.querySelector('.swiper-pagination');
  const contents = el.querySelectorAll('.hero-slider__content');

  const update = () => {
    contents.forEach((el) => (el.style.paddingBottom = `${pagination.offsetHeight + 28}px`));
  };
  window.addEventListener('resize', update);
  update();
});
